<template>
<div class="chapter">
<div class="inner_page">
<div id="lo">
<div class="generated-style">
<p class="gb">Introduction</p>
<p class="gb"> </p>
<p class="text5">I have the smartest readers in the world.</p>
<p class="text5">Is that saying a bit much? Garry Trudeau’s readers are pretty bright, and there’s what’s-his-face Kafka, but
my readers are right up there</p>
<p class="text5">When I created <em class="italic">Frazz</em>, it was with the conceit that newspaper readers are a pretty smart lot. Newspapers
take some effort; you can’t just stare at them slack-jawed and passively let them fill your brainpan with
easy thought-substitute. But you get a good return on that effort, and the people who understand that
are the kind of people I wanted to share my thoughts and stories with. And I got my wish.</p>
<p class="text5">Oopsie.</p>
<p class="text5">There’s a price that comes with readers that smart. Some have figured out that I myself am not that
bright, and a subset of those are only too willing to point that out. Sometimes it’s a minor thing, like the
time Frazz called Ayn Rand’s 1957 classic <em class="italic">Atlas Shrugged</em> one of this century’s toughest epics—in 2001.
I can live with those corrections, and in fact I love them. You wince, you learn, and you move on toward
the inevitable next screwup.</p>
<p class="text5">But once in a while, you make an error so egregious it has to be addressed as soon as deadlines allow. In
newspapers, that means in four to six weeks. In book publishing, now, that’s a whole different schedule
altogether.</p>
<p class="text5">Case in point: I remember being busted by my readers for a particularly stupid error. I needed to atone
for it, and I did so with what turned out to be a terrific series of strips. All was well in newspaper time. In
book time, not so much. The goof was printed in the last few pages of the first <em class="italic">Frazz</em> collection, <em class="italic">Live at Bryson Elementary</em>. The series of strips making up for it had to wait a year for this book.</p>
<p class="text5">But here it is. Enjoy.</p>
<p class="text5">What, exactly, was the screwup? Where’s the correction? Good question. I attributed a quote. . .</p>
<p class="text5">Wait a minute. We were just discussing how my readers are willing to work for their fun. And what fun it
will be for you to scour both books to find those strips! You’ve got this one in your hands. <em class="italic">Frazz: Live at
Bryson Elementary</em> is still in print, and a bargain at $10.95.</p>
<p class="text5">Maybe I’m not so dense after all. At least not according to über-capitalist Ayn Rand, who drove a Prius,
adored Frazz, and threw out the first pitch as her beloved New York Yankees fell, alas, to the Los Angeles
Rams in the 2002 Stanley Cup finals. You can look it up.</p>
<p class="text5">And you just know somebody will.</p>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// LO-07.vue?c5a9cf08